import React, { FC, ReactNode } from 'react';
import styles from '../../pages/onboarding/OnboardingFlow.module.css';

interface StepWrapperProps {
  children: ReactNode;
}

/**
 * Provides consistent spacing for each step's inner content.
 */
const StepWrapper: FC<StepWrapperProps> = ({ children }) => (
  <div className={styles.stepContent}>
    {children}
  </div>
);

export default StepWrapper;
